import { makeAutoObservable, runInAction, action } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants"
import { ErrorWrapper } from "../utils/ErrorWrapper"

interface openMeter {
    [key: string]: boolean;
}
interface getSurveyExperienceID {
    [key: string]: string;
}
interface transactionIDValue {
    [key: string]: string;
}
interface serviceIDParams {
    [key: string]: string;
}
interface deliveryChannelIdparams {
    [key: string]: string;
}
interface Questions {
    surveyQuestionId: string,
    surveyQuestionAR: string,
    surveyQuestionEN: string,
    surveyQuestionHI: string,
}
class HappyMeter {
    questions: Questions[] = [];
    openMeterOrNOt: openMeter = { openMeter: false };
    surveyIDs: getSurveyExperienceID = { surveyExperienceItemId: "" }
    transactionID: transactionIDValue = { transactionID: "" }
    serviceID: serviceIDParams = { serviceID: "1" }
    deliveryChannelId: deliveryChannelIdparams = { deliveryChannelId: "1" }

    constructor() {
        makeAutoObservable(this);
    }

    openHappinessMeter = () => {
        runInAction(() => {
            this.openMeterOrNOt = { openMeter: true }
        })
    }
    closeHappinessMeter = () => {
        runInAction(() => {
            this.openMeterOrNOt = { openMeter: false }
        })
    }
    getSurveyId = async ({ ratingsId, agentName, deviceVersion, userName, userId }: { ratingsId: string, agentName: null, deviceVersion: null, userName: string, userId: string }) => {
        let data = {
            ratingsId,
            deliveryChannelId: this.deliveryChannelId.deliveryChannelId,
            serviceId: this.serviceID.serviceID,
            agentName,
            deviceVersion,
            userName,
            userId,
            transactionID: this.transactionID.transactionID,
            language: "EN"
        }
        const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.GET_HAPPY_METER_EXPERIENCE, type: 'POST', data });
        runInAction(() => {
            this.surveyIDs = {
                surveyExperienceItemId: res.result.surveyExperienceItemId
            }
        })

    }

    setUpTranctionId = (transactionID: string) => {
        this.transactionID = { transactionID: transactionID }
    }
    setUPserviceID = (serviceID: string) => {
        this.serviceID = { serviceID: serviceID }

    }
    getServayQuestions = async (setCurrentScreen: Function) => {
        const res = await callRemoteMethod({ endpoint: `${CONSTANTS.URL.GET_Survey_Question_List}/${this.deliveryChannelId.deliveryChannelId}/${this.serviceID.serviceID}`, type: 'GET' });
        runInAction(() => {
            setCurrentScreen(2)
            this.questions = res.result

        })

    }
    submitFeedback = async (MainRating: any, userComments: any, setCurrentScreen: Function) => {
        const res = await callRemoteMethod({ endpoint: `${CONSTANTS.URL.GET_Survey_Question_List}`, type: 'POST', data: MainRating });
        const resData = await callRemoteMethod({ endpoint: `${CONSTANTS.URL.POSt_Survey_comments}`, type: 'POST', data: userComments });

        if (res.statusCode === 200 && resData.statusCode === 200) {
            setCurrentScreen(4)
        }


    }
}
const HappyMeterStore = new HappyMeter();
export default HappyMeterStore;
